//是否是图片
function isPic(val) {
	let pic = val.toLowerCase()
	if (pic == 'jpeg' || pic == 'gif' || pic == 'jpg' || pic == 'png' || pic == 'bmp' || pic == 'pic'|| pic == 'svg') {
		return true
	} else {
		return false
	}
}
export { //很关键
	isPic
}



// WEBPACK FOOTER //
// ./src/utils/isPicture.js